module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling02-807c511786ea01ffbb503088989a0a90.svg";